import React, { useState, useEffect } from "react";
import { formatINR } from "../../utils/currency";
import Table from "../../UI/Table";
import MasterDeleteModal from "../../UI/MasterDeleteModal/MasterDeleteModal";
import ImageModel from "../../UI/ImageModel/ImageModel";
import MasterFormModel from "../../UI/RejectionFormModel/RejectionFormModel";
import ContextApi from "../../HOC/ContextApi/ContextApi";
import axios from "../../HOC/Axios/Axios";
import { MdDelete, MdEdit, MdMoreVert, MdPeople, MdTrendingUp } from "react-icons/md";
import { BsEyeFill, BsSearch } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import UserDetailFormModel from "../../components/pageComponents/UserDetailFormModel/UserDetailFormModel";
import { BiCoinStack } from "react-icons/bi";
import UserUpdateAmount from "../../components/pageComponents/UserDetailFormModel/UserUpdateAmount";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../../components/pageComponents/Spinner/Spinner";

// ── Helpers ────────────────────────────────────────────────────────────────────
const getInitials = (name = "") =>
  name
    .split(" ")
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() || "")
    .join("");

const avatarColors = [
  "from-violet-500 to-purple-600",
  "from-blue-500 to-indigo-600",
  "from-emerald-500 to-teal-600",
  "from-orange-500 to-amber-600",
  "from-pink-500 to-rose-600",
  "from-cyan-500 to-sky-600",
];
const getColor = (name = "") => {
  const i = name.charCodeAt(0) % avatarColors.length;
  return avatarColors[i];
};

// ── Skeleton Row ───────────────────────────────────────────────────────────────
function SkeletonRow() {
  return (
    <tr className="animate-pulse">
      {[1, 2, 3, 4, 5, 6, 7, 8].map((c) => (
        <td key={c} className="px-5 py-4">
          <div className="h-4 bg-slate-100 rounded-lg w-full" />
        </td>
      ))}
    </tr>
  );
}

// ── Main Component ─────────────────────────────────────────────────────────────
function UserDetails() {
  const navigate = useNavigate();
  const [message, setMessage] = useState(false);
  const [modelClick, setModelClick] = useState(false);
  const [filteredData, setFilteredData] = useState("");
  const [counter, setCounter] = useState(1);
  const [showUserForm, setShowUserForm] = useState(false);
  const [deleteID, setDeleteID] = useState("");
  const [showUpdateAmount, setShowUpdateAmount] = useState(false);
  const [ID, setID] = useState(false);
  const [pagination] = useState({ start: 0, end: 10 });
  const [clickReject, setClickReject] = useState(false);
  const [userId, setUserId] = useState("");
  const [userIds, setUserIds] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [showAction, setShowAction] = useState(false);

  const EndValue = counter * pagination.end;
  const StartValue = EndValue - pagination.end;

  const Thead = [
    { title: "#", width: "4%" },
    { title: "User", width: "20%" },
    { title: "Balance", width: "12%" },
    { title: "Country", width: "11%" },
    { title: "Contact", width: "13%" },
    { title: "Document", width: "10%" },
    { title: "Score", width: "8%" },
    { title: "Actions", width: "10%" },
  ];

  const getUserData = () => {
    setShowLoader(true);
    axios
      .get("/user")
      .then((res) => {
        setTableData(res?.data?.result);
        setShowLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setShowLoader(false);
      });
  };

  useEffect(() => {
    getUserData();
  }, []);

  const Filter = (options) => {
    if (!filteredData) return options;
    const search = filteredData.toLowerCase();
    return options.filter((opt) => {
      const name = (opt?.fullName || "").toLowerCase();
      const phone = opt?.phoneNo || "";
      return name.includes(search) || phone.startsWith(filteredData);
    });
  };

  const Edit = (id) => {
    setShowUserForm(true);
    setUserIds(id);
  };

  const DeleteItems = () => {
    setShowSpinner(true);
    axios
      .delete(`/user/${deleteID}`)
      .then((res) => {
        if (res.status === 200) {
          toast.error(res.data.message);
          setTimeout(() => {
            setShowSpinner(false);
            setMessage(false);
            getUserData();
          }, 900);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.response?.message);
        setShowSpinner(false);
      });
  };

  const Conformation = (id) => {
    setMessage(true);
    setDeleteID(id);
  };

  const UpdateAmount = (val) => {
    setShowUpdateAmount(true);
    setUserId(val);
  };

  const handleImage = (val) => {
    setModelClick(true);
    setID(val);
  };

  const filtered = Filter(tableData || []);

  return (
    <ContextApi>
      {/* Modals */}
      {modelClick && ID.id && (
        <ImageModel image={ID?.validId} message={modelClick} setModelClick={setModelClick} />
      )}
      <ToastContainer autoClose={1000} theme="colored" />
      {showUserForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4 overflow-y-auto">
          <UserDetailFormModel
            getUserData={getUserData}
            setShowUserForm={setShowUserForm}
            userIds={userIds}
          />
        </div>
      )}
      {showSpinner && <Spinner />}
      {showUpdateAmount && (
        <div className="fixed bg-black flex justify-center items-center bg-opacity-40 top-0 left-0 h-full w-full z-50">
          <UserUpdateAmount
            getUserData={getUserData}
            storeAcceptID={userId}
            setShowUpdateAmount={setShowUpdateAmount}
            message={showUpdateAmount}
          />
        </div>
      )}
      {message && (
        <MasterDeleteModal Delete={DeleteItems} setMessage={setMessage} message={message} />
      )}
      {clickReject && (
        <MasterFormModel
          setClickReject={setClickReject}
          clickReject={clickReject}
          message={clickReject}
        />
      )}

      {/* ── Page Content ── */}
      <div className="min-h-screen bg-mainColor px-3 tablet:px-8 py-4 tablet:py-6 space-y-4 tablet:space-y-6">

        {/* ── Page Header ── */}
        <div
          className="relative overflow-hidden rounded-2xl px-4 py-5 tablet:px-6 tablet:py-7 shadow-soft"
          style={{
            background: "linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #312e81 100%)",
          }}
        >
          <div
            className="absolute -top-8 -right-8 w-40 h-40 rounded-full opacity-10"
            style={{ background: "radial-gradient(circle, #7c3aed, transparent)" }}
          />
          <div className="relative z-10 flex flex-col gap-3 tablet:flex-row tablet:items-center tablet:justify-between">
            <div className="flex items-center gap-4">
              <div className="bg-secondMainColor/20 border border-secondMainColor/30 rounded-xl p-3">
                <MdPeople className="text-violet-400 text-2xl" />
              </div>
              <div>
                <h1 className="text-white text-xl font-bold">User Management</h1>
                <p className="text-slate-400 text-sm mt-0.5">
                  {tableData?.length || 0} total registered users
                </p>
              </div>
            </div>

            {/* Search */}
            <div className="relative w-full tablet:w-72">
              <BsSearch className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400 text-sm" />
              <input
                id="user-search"
                type="text"
                placeholder="Search by name or phone…"
                value={filteredData}
                onChange={(e) => {
                  setFilteredData(e.target.value);
                  setCounter(1);
                }}
                className="w-full h-10 pl-9 pr-4 bg-white/10 border border-white/10
                  text-white placeholder:text-slate-500 rounded-xl text-sm
                  focus:outline-none focus:ring-2 focus:ring-secondMainColor/40 focus:bg-white/15
                  transition-all"
              />
            </div>
          </div>
        </div>

        {/* ── Quick Stats ── */}
        <div className="grid grid-cols-2 laptop:grid-cols-4 gap-3 tablet:gap-4">
          {[
            { label: "Total", value: tableData?.length || 0, icon: MdPeople, color: "text-violet-600", bg: "bg-violet-50 border-violet-100" },
            { label: "Filtered", value: filtered?.length || 0, icon: BsSearch, color: "text-blue-600", bg: "bg-blue-50 border-blue-100" },
            { label: "This Page", value: Math.min(pagination.end, filtered?.length || 0), icon: MdTrendingUp, color: "text-emerald-600", bg: "bg-emerald-50 border-emerald-100" },
            { label: "Pages", value: Math.ceil((filtered?.length || 0) / pagination.end) || 1, icon: BiCoinStack, color: "text-amber-600", bg: "bg-amber-50 border-amber-100" },
          ].map((s, i) => (
            <div key={i} className={`flex items-center gap-2 tablet:gap-3 rounded-xl border px-3 tablet:px-4 py-3 bg-white ${s.bg} shadow-sm`}>
              <s.icon className={`text-lg tablet:text-xl flex-shrink-0 ${s.color}`} />
              <div>
                <div className="text-xs text-slate-500 font-medium">{s.label}</div>
                <div className="text-lg tablet:text-xl font-bold text-slate-800">{s.value}</div>
              </div>
            </div>
          ))}
        </div>

        {/* ── Table ── */}
        {showLoader ? (
          <div className="bg-white rounded-2xl border border-slate-200/80 overflow-hidden shadow-sm">
            <div className="w-full overflow-x-auto">
              <table className="w-full min-w-[640px]">
                <thead>
                  <tr className="bg-slate-800">
                    {Thead.map((h, i) => (
                      <th
                        key={i}
                        className="text-left px-5 py-4 text-xs font-semibold text-slate-200 uppercase tracking-wider"
                      >
                        {h.title}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {[...Array(6)].map((_, i) => (
                    <SkeletonRow key={i} />
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : tableData && tableData.length > 0 ? (
          <div className="overflow-x-auto">
            {filtered && filtered.length > 0 ? (
              <Table
                Head={Thead}
                counter={counter}
                setCounter={setCounter}
                data={filtered}
                paginationEnd={pagination.end}
                title="user details"
                StartValue={StartValue}
                EndValue={EndValue}
              >
                {filtered.slice(StartValue, EndValue).map((val, i) => {
                  const initials = getInitials(val?.fullName);
                  const colorClass = getColor(val?.fullName || "");
                  const isActionOpen = showAction && ID === val.id;

                  return (
                    <tr
                      key={val?.id || i}
                      className="group hover:bg-violet-50/40 transition-colors duration-150"
                    >
                      {/* Index */}
                      <td className="px-5 py-4 text-sm text-slate-400 font-medium">
                        {StartValue + 1 + i}
                      </td>

                      {/* User */}
                      <td className="px-5 py-4">
                        <div className="flex items-center gap-3">
                          <div
                            className={`flex-shrink-0 w-9 h-9 rounded-xl bg-gradient-to-br ${colorClass}
                              flex items-center justify-center text-white text-xs font-bold shadow-sm`}
                          >
                            {initials || "?"}
                          </div>
                          <div className="min-w-0">
                            <div className="font-semibold text-slate-800 text-sm leading-tight truncate">
                              {val?.fullName || "—"}
                            </div>
                            <div className="text-xs text-slate-400 truncate max-w-[160px] mt-0.5">
                              {val?.email || "—"}
                            </div>
                          </div>
                        </div>
                      </td>

                      {/* Balance */}
                      <td className="px-5 py-4">
                        <span className="inline-flex items-center gap-1 font-semibold text-slate-800 text-sm">
                          {formatINR(val?.amount?.balance || 0)}
                        </span>
                      </td>

                      {/* Country */}
                      <td className="px-5 py-4">
                        {val?.country ? (
                          <span className="inline-flex items-center px-2.5 py-1 rounded-lg bg-slate-100 text-slate-700 text-xs font-medium capitalize">
                            {val.country}
                          </span>
                        ) : (
                          <span className="text-slate-300 text-sm">—</span>
                        )}
                      </td>

                      {/* Contact */}
                      <td className="px-5 py-4 text-sm text-slate-600">
                        {val?.phoneNo || <span className="text-slate-300">—</span>}
                      </td>

                      {/* Document */}
                      <td className="px-5 py-4">
                        <button
                          onClick={() => handleImage(val)}
                          title="View document"
                          className="relative w-11 h-11 rounded-xl overflow-hidden ring-2 ring-slate-100
                            hover:ring-secondMainColor/40 transition-all cursor-pointer group/doc"
                        >
                          {val?.validId ? (
                            <>
                              <img
                                src={val.validId}
                                alt="Document"
                                className="w-full h-full object-cover"
                              />
                              <div className="absolute inset-0 bg-black/30 opacity-0 group-hover/doc:opacity-100 transition-opacity flex items-center justify-center">
                                <BsEyeFill className="text-white text-sm" />
                              </div>
                            </>
                          ) : (
                            <div className="w-full h-full bg-slate-100 flex items-center justify-center">
                              <span className="text-slate-300 text-xs">—</span>
                            </div>
                          )}
                        </button>
                      </td>

                      {/* Score */}
                      <td className="px-5 py-4">
                        {(() => {
                          const score = val?.creditScore ?? 0;
                          const color =
                            score >= 700
                              ? "bg-emerald-100 text-emerald-700"
                              : score >= 400
                                ? "bg-amber-100 text-amber-700"
                                : "bg-red-100 text-red-600";
                          return (
                            <span
                              className={`inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-bold ${color}`}
                            >
                              {score}
                            </span>
                          );
                        })()}
                      </td>

                      {/* Actions */}
                      <td className="px-5 py-4">
                        <div
                          className="relative inline-block"
                          onMouseLeave={() => setShowAction(false)}
                        >
                          <button
                            id={`action-btn-${val.id}`}
                            onClick={() => {
                              setShowAction(isActionOpen ? false : true);
                              setID(val.id);
                            }}
                            className="p-2 rounded-lg hover:bg-slate-100 text-slate-500
                              hover:text-slate-800 transition-colors group-hover:bg-slate-100"
                          >
                            <MdMoreVert className="w-5 h-5" />
                          </button>

                          {isActionOpen && (
                            <div
                              className="absolute right-0 top-full mt-1.5 py-1.5 bg-white rounded-xl
                                shadow-dropdown border border-slate-100 min-w-[190px] z-50"
                              onMouseEnter={() => setShowAction(true)}
                            >
                              {/* View */}
                              <button
                                className="w-full px-4 py-2.5 text-left text-sm flex items-center gap-2.5
                                  hover:bg-violet-50 text-slate-700 hover:text-violet-700 transition-colors"
                                onClick={() => {
                                  navigate(`/user_details/${val.id}`, {
                                    state: { withdraw: true, deposit: true, trade: true },
                                  });
                                  setShowAction(false);
                                }}
                              >
                                <div className="w-7 h-7 rounded-lg bg-violet-100 flex items-center justify-center">
                                  <BsEyeFill className="text-violet-600 text-xs" />
                                </div>
                                View Profile
                              </button>

                              {/* Edit */}
                              <button
                                className="w-full px-4 py-2.5 text-left text-sm flex items-center gap-2.5
                                  hover:bg-blue-50 text-slate-700 hover:text-blue-700 transition-colors"
                                onClick={() => {
                                  Edit(val.id);
                                  setShowAction(false);
                                }}
                              >
                                <div className="w-7 h-7 rounded-lg bg-blue-100 flex items-center justify-center">
                                  <MdEdit className="text-blue-600 text-xs" />
                                </div>
                                Edit User
                              </button>

                              {/* Update amount */}
                              <button
                                className="w-full px-4 py-2.5 text-left text-sm flex items-center gap-2.5
                                  hover:bg-emerald-50 text-slate-700 hover:text-emerald-700 transition-colors"
                                onClick={() => {
                                  UpdateAmount(val);
                                  setShowAction(false);
                                }}
                              >
                                <div className="w-7 h-7 rounded-lg bg-emerald-100 flex items-center justify-center">
                                  <BiCoinStack className="text-emerald-600 text-xs" />
                                </div>
                                Update Balance
                              </button>

                              <div className="my-1 mx-3 border-t border-slate-100" />

                              {/* Delete */}
                              <button
                                className="w-full px-4 py-2.5 text-left text-sm flex items-center gap-2.5
                                  hover:bg-red-50 text-red-500 hover:text-red-600 transition-colors"
                                onClick={() => {
                                  Conformation(val.id);
                                  setShowAction(false);
                                }}
                              >
                                <div className="w-7 h-7 rounded-lg bg-red-100 flex items-center justify-center">
                                  <MdDelete className="text-red-500 text-xs" />
                                </div>
                                Delete User
                              </button>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </Table>
            ) : (
              /* No search results */
              <div className="bg-white rounded-2xl border border-slate-100 p-16 text-center shadow-sm">
                <div className="w-16 h-16 bg-slate-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <BsSearch className="text-slate-400 text-2xl" />
                </div>
                <h3 className="text-slate-700 font-semibold text-base mb-1">No results found</h3>
                <p className="text-slate-400 text-sm">
                  No users match "<span className="font-medium text-slate-600">{filteredData}</span>"
                </p>
                <button
                  onClick={() => setFilteredData("")}
                  className="mt-4 px-4 py-2 bg-secondMainColor text-white rounded-lg text-sm font-medium hover:bg-secondMainColorDark transition-colors"
                >
                  Clear search
                </button>
              </div>
            )}
          </div>
        ) : (
          /* Empty state */
          <div className="bg-white rounded-2xl border border-slate-100 overflow-hidden shadow-sm">
            <table className="w-full">
              <thead className="bg-slate-800">
                <tr>
                  {Thead.map((h, i) => (
                    <th
                      key={i}
                      className="text-left px-5 py-4 text-xs font-semibold text-slate-200 uppercase tracking-wider"
                    >
                      {h.title}
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
            <div className="flex flex-col items-center justify-center py-24 gap-4">
              <div className="w-20 h-20 bg-slate-50 rounded-2xl flex items-center justify-center border border-slate-100">
                <MdPeople className="text-slate-300 text-4xl" />
              </div>
              <div className="text-center">
                <p className="text-slate-700 font-semibold">No users yet</p>
                <p className="text-slate-400 text-sm mt-1">Users will appear here once they register</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </ContextApi>
  );
}

export default UserDetails;
